import ApiService from './ApiService';
export default {
    azureStorage: require('azure-storage'),
    azureStorageBrowser: require('azure-storage/browser/azure-storage.blob.export'),
    AzureStorage: process.env.REACT_APP_URL_AZURE_STORAGE,
    name: process.env.REACT_APP_AZURE_STORAGE_ACCOUNT_NAME,
    QueueStorage:process.env.REACT_APP_URL_AZURE_QUEUE,
    QueueAsset: process.env.REACT_APP_QUEUE,

    async connection (containerName, type, file, data) {
        const dataConnection = {
            accountName:this.name,
            container: containerName,
            fileList: file,
            finishedOrError: false,
            sasToken: data.sasToken,
            uploading: false,
        };
        const queueUri =this.AzureStorage;
        const storageService = await this.createBlob({...dataConnection, uri: queueUri})
        return storageService;
    },

    async createBlob (data={}, file, token={}, migrateData){
        const dataConnection = {
            accountName: this.name,
            container: token.idContainer,
            fileList: file,
            finishedOrError: false,
            sasToken: token.sasToken,
            uploading: false,
            assetId: token.assetId,
            azureStorage: require('azure-storage'),
            azureStorageBrowser:  require('azure-storage/browser/azure-storage.blob.export')
        };
        const queueUri = this.AzureStorage;
        const browserConnect = dataConnection.azureStorageBrowser.createBlobServiceWithSas(queueUri, dataConnection.sasToken)
        const myfile = data.fileList[0];
        return new Promise((resolve, reject) => {
            browserConnect.createBlockBlobFromBrowserFile(dataConnection.container, myfile.name, myfile,  (error, res) => {
                if (error) {
                    reject(error);
                } else {
                    // this.createQueue(dataConnection, migrateData).then(
                    //     result => {
                    resolve({ message: "Blob", successBlob: true, successQueue: true });
                        // }, error => {
                        //     reject(error)
                        // }
                    //);
                }
            });
        });
    },

    async createQueue (data={}) {
        const queueUri = this.QueueStorage;
        const connect = this.azureStorage.createQueueServiceWithSas(queueUri, data.sasToken);
        const queue = this.QueueAsset;
        const file = data.fileList[0];
        return new Promise((resolve, reject) => {
            connect.createQueueIfNotExists(queue, function(error, result, response) {
                if (!error) {
                    resolve({message: 'blob and Message inserted', })
                } else {
                    reject(error)

                }
            });
        });
    },
    async migrateData (data={}, fileName) {
        data = {
            assetId: data.assetId,
            idCourse: data.idCourse,
            VideoLength: data.videoLength,
            MultimediaName: data.multimediaName
            }
            await ApiService.setMigrateMediaServices(data);
        },
    }